// Supervisor app update API (SUPERADMIN only)

import axiosInstance from './axiosInstance';
import { API_ENDPOINTS } from '../config/api.config';

const { APP_UPDATE } = API_ENDPOINTS;

export const appUpdateApi = {
  /** POST /admin/app-update/push/ — { version?, note? }, both optional.
   *  Notifies EVERY supervisor device at once; the reply carries
   *  { message, devices, version } where `devices` is how many phones it
   *  actually reached. */
  push: (data = {}) => axiosInstance.post(APP_UPDATE.PUSH, data),

  /** GET /admin/app-update/ — { latest_version, min_version, note, store_url }. */
  getRelease: () => axiosInstance.get(APP_UPDATE.RELEASE),

  /** PUT /admin/app-update/ — { latest_version?, min_version?, note? }.
   *  min_version is the one that BLOCKS: a phone on an older build is shown
   *  an update screen it cannot dismiss. Empty string lifts the block. */
  saveRelease: (data = {}) => axiosInstance.put(APP_UPDATE.RELEASE, data),
};
